import { render } from "./crTaskEdit.vue?vue&type=template&id=ad08d5fe&scoped=true&ts=true"
import script from "./crTaskEdit.vue?vue&type=script&lang=ts"
export * from "./crTaskEdit.vue?vue&type=script&lang=ts"

import "./crTaskEdit.vue?vue&type=style&index=0&id=ad08d5fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad08d5fe"]])

export default __exports__